import { render, staticRenderFns } from "./cloudService.vue?vue&type=template&id=82fd8ce6&"
import script from "./cloudService.vue?vue&type=script&lang=js&"
export * from "./cloudService.vue?vue&type=script&lang=js&"
import style0 from "./cloudService.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports